module.exports = __webpack_public_path__ + "thaisansneue-regular-webfont.5db3f5c8be1a34117993.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/css/fonts/thaisansneue-regular-webfont.woff
// module id = ../../../../../src/assets/corporate/css/fonts/thaisansneue-regular-webfont.woff
// module chunks = styles